"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$formatStruct = exports.$styleStruct = exports.$noteStruct = exports.makeNoteLikeStructRule = exports.$format = exports.$style = exports.$note = exports.makeNoteLikeRule = exports.noteLikeStructToLines = exports.noteLikeToLines = exports.noteLikeStructControl = void 0;
const factory_1 = require("../factory");
const line_1 = require("../../../node/cst/line");
const util_1 = require("../util");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const inline_1 = require("../../../node/cst/inline");
const el_1 = require("../../../node/el");
const util_2 = require("../../../util");
const _remarks_1 = __importStar(require("./$remarks"));
const _any_1 = __importStar(require("./$any"));
const _sentencesArray_1 = require("../../cst/rules/$sentencesArray");
const columnsOrSentences_1 = require("./columnsOrSentences");
const parse_1 = __importDefault(require("../../cst/parse"));
const _otherLine_1 = require("../../cst/rules/$otherLine");
/**
 * The renderer for note-like item ({@link std.NoteLike | NoteLike}). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
exports.noteLikeStructControl = {
    NoteStruct: ":note-struct:",
    StyleStruct: ":style-struct:",
    FormatStruct: ":format-struct:",
};
const noteLikeToLines = (noteLike, indentTexts) => {
    const lines = [];
    if (noteLike.children.every(std.isColumn) || noteLike.children.every(std.isSentence)) {
        const line = new line_1.OtherLine({
            range: null,
            indentTexts,
            controls: [],
            sentencesArray: (0, columnsOrSentences_1.columnsOrSentencesToSentencesArray)(noteLike.children),
            lineEndText: toCSTSettings_1.default.EOL,
        });
        const lineText = (0, _sentencesArray_1.sentencesArrayToString)(line.sentencesArray);
        try {
            const parsedLines = (0, parse_1.default)(lineText);
            if (parsedLines.value[0].type !== line_1.LineType.OTH) {
                line.controls.push(new inline_1.Control(_otherLine_1.ignoreTitleControl, null, "", null));
            }
        }
        catch {
            //
        }
        lines.push(line);
    }
    else {
        lines.push(...noteLike.children.map(c => (0, _any_1.anyToLines)(c, indentTexts)).flat());
    }
    return lines;
};
exports.noteLikeToLines = noteLikeToLines;
/**
 * The renderer for note-like struct item ({@link std.NoteLikeStruct | NoteLikeStruct}). Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
const noteLikeStructToLines = (noteLikeStruct, indentTexts) => {
    const lines = [];
    const noteLikeStructTitleTag = std_1.noteLikeStructTitleTags[std_1.noteLikeStructTags.indexOf(noteLikeStruct.tag)];
    const noteLikeStructTitleSentenceChildren = noteLikeStruct.children
        .find(el => el.tag === noteLikeStructTitleTag)?.children;
    lines.push(new line_1.OtherLine({
        range: null,
        indentTexts,
        controls: [
            new inline_1.Control(exports.noteLikeStructControl[noteLikeStruct.tag], null, "", null)
        ],
        sentencesArray: noteLikeStructTitleSentenceChildren ? [
            new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, noteLikeStructTitleSentenceChildren)])
        ] : [],
        lineEndText: toCSTSettings_1.default.EOL,
    }));
    const childrenIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
    for (const child of noteLikeStruct.children) {
        if ((0, std_1.isNoteLikeStructTitle)(child))
            continue;
        if ((0, std_1.isNoteLike)(child)) {
            lines.push(...(0, exports.noteLikeToLines)(child, childrenIndentTexts));
        }
        else if (child.tag === "Remarks") {
            const remarksLines = (0, _remarks_1.remarksToLines)(child, childrenIndentTexts);
            lines.push(...remarksLines);
        }
        else {
            (0, util_2.assertNever)(child);
        }
    }
    return lines;
};
exports.noteLikeStructToLines = noteLikeStructToLines;
const makeNoteLikeRule = (tag) => factory_1.factory
    .withName("noteLike")
    .sequence(s => s
    .and(() => _any_1.default, "any")
    .action(({ any }) => {
    const el = (0, std_1.newStdEL)(tag, {}, any.value);
    el.range = (0, el_1.rangeOfELs)(el.children);
    return {
        value: el,
        errors: any.errors,
    };
}));
exports.makeNoteLikeRule = makeNoteLikeRule;
/**
 * The parser rule for {@link std.Note}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
exports.$note = (0, exports.makeNoteLikeRule)("Note");
/**
 * The parser rule for {@link std.Style}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
exports.$style = (0, exports.makeNoteLikeRule)("Style");
/**
 * The parser rule for {@link std.Format}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
exports.$format = (0, exports.makeNoteLikeRule)("Format");
const noteLikeRules = {
    NoteStruct: exports.$note,
    StyleStruct: exports.$style,
    FormatStruct: exports.$format,
};
const makeNoteLikeStructRule = (tag) => {
    const noteLikeRule = noteLikeRules[tag];
    const sublistsBlockRule = (factory_1.factory
        .sequence(s => s
        .and(r => r
        .ref((0, util_1.makeIndentBlockWithCaptureRule)(`$${tag[0].toLowerCase()}${tag.slice(1)}ChildrenBlock`, (factory_1.factory
        .choice(c => c
        .or(() => _remarks_1.default)
        .or(() => noteLikeRule))))), "block")
        .action(({ block }) => {
        return {
            value: block.value.map(v => v.value),
            errors: [
                ...block.value.map(v => v.errors).flat(),
                ...block.errors,
            ]
        };
    })));
    return factory_1.factory
        .withName("noteLikeStruct")
        .sequence(s => s
        .and(r => r
        .oneMatch(({ item }) => {
        if (item.type === line_1.LineType.OTH
            && item.line.type === line_1.LineType.OTH
            && item.line.controls.some(c => c.control === exports.noteLikeStructControl[tag])) {
            return item;
        }
        else {
            return null;
        }
    }), "titleLine")
        .and(r => r.zeroOrMore(() => util_1.$blankLine))
        .and(r => r
        .zeroOrOne(() => sublistsBlockRule), "childrenBlock")
        .action(({ titleLine, childrenBlock }) => {
        const children = [];
        const errors = [];
        const noteLikeStructTitleSentenceChildren = (0, _sentencesArray_1.forceSentencesArrayToSentenceChildren)(titleLine.line.sentencesArray);
        const noteLikeStructTitle = noteLikeStructTitleSentenceChildren.length > 0 ? (0, std_1.newStdEL)(std.noteLikeStructTitleTags[std.noteLikeStructTags.indexOf(tag)], {}, noteLikeStructTitleSentenceChildren, titleLine.line.sentencesArrayRange) : null;
        if (noteLikeStructTitle) {
            children.push(noteLikeStructTitle);
        }
        if (childrenBlock) {
            children.push(...childrenBlock.value);
            errors.push(...childrenBlock.errors);
        }
        const pos = titleLine.line.indentsEndPos;
        const range = (0, el_1.rangeOfELs)(children) ?? (pos !== null ? [pos, pos] : null);
        if (range && pos !== null) {
            range[0] = pos;
        }
        const noteLikeStruct = (0, std_1.newStdEL)(tag, {}, children, range);
        return {
            value: noteLikeStruct,
            errors,
        };
    }));
};
exports.makeNoteLikeStructRule = makeNoteLikeStructRule;
/**
 * The parser rule for {@link std.NoteStruct}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
exports.$noteStruct = (0, exports.makeNoteLikeStructRule)("NoteStruct");
/**
 * The parser rule for {@link std.StyleStruct}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
exports.$styleStruct = (0, exports.makeNoteLikeStructRule)("StyleStruct");
/**
 * The parser rule for {@link std.FormatStruct}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$noteLike.spec.ts) for examples.
 */
exports.$formatStruct = (0, exports.makeNoteLikeStructRule)("FormatStruct");
//# sourceMappingURL=$noteLike.js.map